import { useId } from "react";
import { LayoutGroup, motion, useReducedMotion } from "framer-motion";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";

const BRAND = "#682243";

function Segments({ items, value, onChange, groupId, disabled, compact = false }) {
  const reducedMotion = useReducedMotion();
  return (
    <Box role="group" aria-label={compact ? "Страна доставки за пределами России" : "Направление доставки"}
      sx={{ display: "grid", gridTemplateColumns: compact ? "1fr 1fr" : "0.8fr 1.2fr",
        gap: "4px", p: "4px", borderRadius: "999px", border: "1px solid #68224326",
        bgcolor: "background.surface", minWidth: 0 }}>
      {items.map(item => (
        <Box key={item.value} component="button" type="button" disabled={disabled}
          aria-pressed={value === item.value} onClick={() => onChange(item.value)}
          sx={{ position: "relative", border: 0, minWidth: 0, minHeight: compact ? 36 : 42,
            px: { xs: 1, sm: 1.5 }, py: 0.75, borderRadius: "999px", bgcolor: "transparent",
            color: value === item.value ? "#fff" : BRAND, cursor: disabled ? "default" : "pointer",
            fontFamily: "inherit", fontWeight: 700, fontSize: compact ? 13 : { xs: 12, sm: 14 },
            opacity: disabled ? 0.6 : 1, transition: "color .18s",
            "&:focus-visible": { outline: `2px solid ${BRAND}`, outlineOffset: "2px" } }}>
          {value === item.value && (
            <motion.span layoutId={`${groupId}-pill`} initial={false}
              transition={reducedMotion ? { duration: 0 } : { type: "spring", stiffness: 420, damping: 34 }}
              style={{ position: "absolute", inset: 0, borderRadius: 999, background: BRAND,
                boxShadow: "0 2px 6px rgba(104,34,67,.18)", pointerEvents: "none" }} />
          )}
          <span style={{ position: "relative", zIndex: 1 }}>{item.label}</span>
        </Box>
      ))}
    </Box>
  );
}

export default function DeliveryCountrySwitch({ countryCode, onChange, disabled = false }) {
  const id = useId();
  const foreign = countryCode === "BY" || countryCode === "KZ";
  return (
    <LayoutGroup id={id}>
      <Box>
        <Typography level="body-xs" sx={{ mb: 0.75, color: "text.secondary", fontWeight: 600 }}>
          Страна доставки
        </Typography>
        <Segments groupId={`${id}-direction`} disabled={disabled}
          items={[{ value: "RU", label: "Россия" }, { value: "FOREIGN", label: "Беларусь, Казахстан" }]}
          value={foreign ? "FOREIGN" : "RU"}
          onChange={value => onChange(value === "RU" ? "RU" : foreign ? countryCode : "BY")} />
        {foreign && (
          <Box sx={{ mt: 1 }}>
            <Segments groupId={`${id}-country`} compact disabled={disabled}
              items={[{ value: "BY", label: "Беларусь" }, { value: "KZ", label: "Казахстан" }]}
              value={countryCode} onChange={onChange} />
            <Typography level="body-xs" sx={{ mt: 0.75, color: "text.secondary" }}>
              Доставка за пределы России · {countryCode === "BY" ? "Беларусь" : "Казахстан"}
            </Typography>
          </Box>
        )}
      </Box>
    </LayoutGroup>
  );
}
